import React from 'react';
import { Cta } from './Cta';
export function Garantia() {
  return <section aria-labelledby="garantia-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-117" data-mp="nofvqhed6fs6">
      <div className="mx-auto max-w-3xl rounded-3xl border border-brand-200 bg-soft p-8 text-center sm:p-12" data-id="element-118" data-mp="1x7ganqi67b0o">
        <p className="text-4xl" aria-hidden="true" data-id="element-119" data-mp="273jklij9kdy6">
          🛡️
        </p>
        <h2 id="garantia-titulo" className="mt-4 font-display text-3xl font-bold text-ink" data-id="element-120" data-mp="271gku6sb76g9">
          Garantía de 7 días sin preguntas
        </h2>
        <p className="mt-2 font-semibold text-brand-700" data-id="element-121" data-mp="2g3pxb27519wa">Tu inversión está protegida</p>

        <p className="mx-auto mt-6 max-w-xl leading-relaxed text-body" data-id="element-122" data-mp="2kv7sf9mhcg9c">
          Accedé al sistema completo, revisá los 6 tomos y los 5 bonos, aplicalo con tus clientas y comprobá
          por vos misma si transforma tu trabajo.
        </p>
        <p className="mx-auto mt-4 max-w-xl leading-relaxed text-muted" data-id="element-123" data-mp="2uuoznvhdr27f">
          Si dentro de los primeros 7 días no es lo que esperabas, te devolvemos el 100% de tu inversión. Sin
          preguntas. Sin trámites complicados. Sin vueltas.
        </p>
        <p className="mt-6 font-display text-xl font-bold text-ink" data-id="element-124" data-mp="3amwdzbc9gr04">
          El riesgo es cero. La decisión es tuya.
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-125" data-mp="35ob92ym2dj5c">
          <Cta data-id="element-126" data-mp="30oovup68k2wj">Obtener el acceso AHORA</Cta>
          <p className="mt-3 text-sm text-muted" data-id="element-127" data-mp="30pqi7pspcbtk">Con garantía de 7 días incluida</p>
        </div>
      </div>
    </section>;
}